module.exports = "pegasus_template/assets/tech/small/1.jpg";